module.exports = __webpack_public_path__ + "assets/android-chrome-192x192.png";


//////////////////
// WEBPACK FOOTER
// ../src/client/assets/icons/android-chrome-192x192.png
// module id = 1018
// module chunks = 19